import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=5bdb600e&"
import script from "./FeedbackCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports